import { render, staticRenderFns } from "./ChargersNearbyCard.vue?vue&type=template&id=5cfb5046"
import script from "./ChargersNearbyCard.vue?vue&type=script&lang=ts"
export * from "./ChargersNearbyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports